import axiosInstance from './axios.service';
import { loadPointsList } from './points.service';
import { constructAdditivesDTO } from '@/utils/additives.utils';
import { getModifiersList } from './goods.service';

const MOCK_DELAY = 300;
const mockDelay = (data) => new Promise((resolve) => setTimeout(() => resolve(data), MOCK_DELAY));

let MOCK_GROUPS = [];
let MOCK_ADDITIVES = [];

export const getPointsAdditives = async (data, headers = {}) => {
  try {
    const pointsPromise = loadPointsList({}, headers);

    const [pointsResponse] = await Promise.all([pointsPromise]);

    const pointsList = Array.isArray(pointsResponse)
      ? pointsResponse
      : Array.isArray(pointsResponse?.data)
        ? pointsResponse.data
        : [];

    const realModifiersByPoints = await Promise.all(
      pointsList.map(async (point) => {
        const pointId = point?.id;
        if (!pointId) return [];
        return getModifiersList(pointId);
      }),
    );

    const mappedModifiers = realModifiersByPoints.flat().map((mod) => ({
      id: mod.id,
      groupId: mod.groupId || null,
      pointId: mod.pointId,
      name: mod.name,
      price: mod.price,
      isVisible: mod.isVisible,
      isAvailable: !mod.deleted,
      imgUrl: mod.imgUrl || '',
      sku: mod.sku || '',
    }));

    // DTO Construction
    // Группы не подмешиваем моками: пока бэкенд не отдаёт список групп, показываем только "ДОБАВКИ БЕЗ ГРУППЫ"
    const result = constructAdditivesDTO(pointsList, [], mappedModifiers);

    return result;
  } catch (error) {
    console.error('Error posting:axios:getPointsAdditives data:', error);
    return [];
  }
};

export const setAdditiveGroup = async (data, headers = {}) => {
  // const url = '/operator/additives/groups/create';
  try {
    // const response = await axiosInstance.post(url, data, { headers });
    console.log('MOCK setAdditiveGroup:', data);
    const newGroup = {
      ...data,
      id: `g${Date.now()}`,
      sortNum: MOCK_GROUPS.filter((g) => g.pointId === data.pointId).length + 1,
    };
    MOCK_GROUPS.push(newGroup);
    return await mockDelay(newGroup);
  } catch (error) {
    console.error('Error posting:axios:setAdditiveGroup data:', error);
  }
};

export const updateAdditiveGroup = async (data, headers = {}) => {
  // const url = '/operator/additives/groups/update';
  try {
    // const response = await axiosInstance.post(url, data, { headers });
    console.log('MOCK updateAdditiveGroup:', data);
    const index = MOCK_GROUPS.findIndex((g) => g.id === data.id);
    if (index !== -1) {
      MOCK_GROUPS[index] = { ...MOCK_GROUPS[index], ...data };
      return await mockDelay(MOCK_GROUPS[index]);
    }
    return await mockDelay({ error: 'Group not found' });
  } catch (error) {
    console.error('Error posting:axios:updateAdditiveGroup data:', error);
  }
};

export const dndAdditiveGroups = async (data, headers = {}) => {
  // const url = '/operator/additives/groups/shift';
  try {
    // const response = await axiosInstance.post(url, data, { headers });
    console.log('MOCK dndAdditiveGroups:', data);
    return await mockDelay({ success: true });
  } catch (error) {
    console.error('Error posting:axios:dndAdditiveGroups data:', error);
  }
};

export const deleteAdditiveGroup = async (data, headers = {}) => {
  // const url = '/operator/additives/groups/delete';
  try {
    // const response = await axiosInstance.post(url, data, { headers });
    console.log('MOCK deleteAdditiveGroup:', data);
    MOCK_GROUPS = MOCK_GROUPS.filter((g) => g.id !== data.groupId);
    return await mockDelay({ success: true });
  } catch (error) {
    console.error('Error posting:axios:deleteAdditiveGroup data:', error);
  }
};

export const dndAdditives = async (data, headers = {}) => {
  // const url = '/operator/additives/shift';
  try {
    // const response = await axiosInstance.post(url, data, { headers });
    console.log('MOCK dndAdditives:', data);
    return await mockDelay({ success: true });
  } catch (error) {
    console.error('Error posting:axios:dndAdditives data:', error);
  }
};

export const axDeleteAdditive = async (data, headers = {}) => {
  // const url = '/operator/additives/delete';
  try {
    // const response = await axiosInstance.post(url, data, { headers });
    console.log('MOCK axDeleteAdditive:', data);
    MOCK_ADDITIVES = MOCK_ADDITIVES.filter((a) => a.id !== data.id);
    return await mockDelay({ success: true });
  } catch (error) {
    console.error('Error posting:axios:axDeleteAdditive data:', error);
  }
};

export const setNewAdditive = async (data, headers = {}) => {
  // const url = '/operator/additives/create';
  try {
    // const response = await axiosInstance.post(url, data, { headers });
    console.log('MOCK setNewAdditive:', data);
    const newAdditive = {
      ...data,
      id: `a${Date.now()}`,
    };
    MOCK_ADDITIVES.push(newAdditive);
    return await mockDelay(newAdditive);
  } catch (error) {
    console.error('Error posting:axios:setNewAdditive data:', error);
  }
};

export const axUpdateAdditive = async (data, headers = {}) => {
  // const url = '/operator/additives/update';
  try {
    // const response = await axiosInstance.post(url, data, { headers });
    console.log('MOCK axUpdateAdditive:', data);
    const index = MOCK_ADDITIVES.findIndex((a) => a.id === data.id);
    if (index !== -1) {
      MOCK_ADDITIVES[index] = { ...MOCK_ADDITIVES[index], ...data };
      return await mockDelay(MOCK_ADDITIVES[index]);
    }
    return await mockDelay({ error: 'Additive not found' });
  } catch (error) {
    console.error('Error posting:axios:axUpdateAdditive data:', error);
  }
};

export const axGetAdditives = async (data, headers = {}) => {
  // const url = '/operator/additives/load';
  try {
    // const response = await axiosInstance.post(url, data, { headers });
    console.log('MOCK axGetAdditives:', data);
    // data.goodsIds array
    if (data.goodsIds && Array.isArray(data.goodsIds)) {
      const found = MOCK_ADDITIVES.filter((a) => data.goodsIds.includes(a.id));
      return await mockDelay(found);
    }
    return await mockDelay([]);
  } catch (error) {
    console.error('Error posting:axios:axGetAdditives data:', error);
  }
};
